export default "__VITE_ASSET__DCCIrP7U__"